import QlReq from '~/utils/ql-req'
import { deShopId, reShopId } from '~/utils/helpers'

const useVintInventoryHook = () => {

  const get_prodinv = async ( shop_id ) => {
    let new_inv = await invj([reShopId(shop_id)])
    new_inv = Object.keys(new_inv).map(k => new_inv[k]).filter(x => !!x)
    const prod = new_inv[0]

    const obj = {
      id: deShopId(prod.id),
      available: prod.availableForSale,
      first_full_price: parseInt(prod.priceRange.maxVariantPrice.amount),
      first_product_price: parseInt(prod.priceRange.minVariantPrice.amount)
    }

    return new Promise((resolve, reject) => {
      resolve( obj )
    })
  }

  const get_collinv = async ( products ) => {
    const vint_prods = products.map(x => reShopId(x.shop_id))
    let new_inv = await invj(vint_prods)
    new_inv = Object.keys(new_inv).map(k => new_inv[k]).filter(x => !!x)

    const formatted_inv = new_inv.map(v => {
      const obj = {
        id: deShopId(v.id),
        available: v.availableForSale,
        first_full_price: parseInt(v.priceRange.maxVariantPrice.amount),
        first_product_price: parseInt(v.priceRange.minVariantPrice.amount)
      }
      return obj
    })

    return new Promise((resolve, reject) => {
      resolve( formatted_inv )
    })
  }

  const qltxt = ( shopify_id ) => {
    return `p${shopify_id.replace('gid://shopify/Product/','')}: product(id:"${shopify_id}") {id\navailableForSale\npriceRange{minVariantPrice{amount}\nmaxVariantPrice{amount}}}`
  }

  const invj = async ( products ) => {
    let query = '{'
    products.forEach( x => query += qltxt(x) )
    query += '}'

    const req = await QlReq.post(query, {})
    return req
  }

  return { get_prodinv, get_collinv }

};

export default useVintInventoryHook;

